import { initialState, Store } from "./types"

const STORAGE_KEY = "ua_demo_app"

export function persistState(state: Store): void {
  try {
    const serialized = JSON.stringify(state)
    localStorage.setItem(STORAGE_KEY, serialized)
  } catch (e) {
    console.error("error persisting state", e)
  }
}

export function loadState(): Store | undefined {
  try {
    const serialized = localStorage.getItem(STORAGE_KEY)
    if (!serialized) return
    const data: Store = JSON.parse(serialized)
    // persist some keys in that we may have added
    return localStorageMigration(data)
  } catch (e) {
    console.error("error loading state")
    return
  }
}

export function localStorageMigration(data: Store): Store {
  const { debug, metadata, contact, channel, analytics } = initialState
  const {
    metadata: storedMetadata,
    contact: storedContact,
    channel: storedChannel,
    analytics: storedAnalytics,
  } = data
  return {
    // don't persist debug state; it will be repopulated
    debug,
    metadata: { ...metadata, ...storedMetadata },
    contact: { ...contact, ...storedContact },
    channel: { ...channel, ...storedChannel },
    analytics: { ...analytics, ...storedAnalytics },
  }
}
